/**
 * PlayerSubmenuItem Container Component
 *
 * Handles logic for player selection callback in submenu items.
 * @module components/HeaderCreateMenu/PlayerSubmenuItem
 */

import React, { memo, useCallback } from "react";

import PlayerSubmenuItemView from "./PlayerSubmenuItemView";

/**
 * Recent player item for display in menus
 */
interface RecentPlayerItem {
  id: string;
  name: string;
}

/**
 * Props for PlayerSubmenuItem component
 */
interface PlayerSubmenuItemProps {
  player: RecentPlayerItem;
  onSelectPlayer: (playerId: string) => void;
  itemClassName: string;
  iconBoxClassName: string;
  iconClassName: string;
  nameClassName: string;
}

/**
 * Container component managing player selection logic.
 * @param root0 - Component props
 */
const PlayerSubmenuItemContainer = memo(
  ({
    player,
    onSelectPlayer,
    itemClassName,
    iconBoxClassName,
    iconClassName,
    nameClassName,
  }: PlayerSubmenuItemProps) => {
    const handlePress = useCallback(() => {
      onSelectPlayer(player.id);
    }, [onSelectPlayer, player.id]);

    return (
      <PlayerSubmenuItemView
        player={player}
        onPress={handlePress}
        itemClassName={itemClassName}
        iconBoxClassName={iconBoxClassName}
        iconClassName={iconClassName}
        nameClassName={nameClassName}
      />
    );
  }
);

PlayerSubmenuItemContainer.displayName = "PlayerSubmenuItemContainer";

export default PlayerSubmenuItemContainer;
